<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Compliance Item'"
      [canGoBack]="!windowService.isDesktopRes"
      [showLoadingSpinner]="isSaving" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (!loaded) {
      @for (i of [1,2,3]; track i) {
        <div style="width: 100%; margin-bottom: 8px;">
          <ion-skeleton-text animated="true" style="height: 44px; border-radius: 6px" />
        </div>
      }
    }

    @if (loaded && item) {
      @if (item.is_tax) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'This is a tax-related item.'" />
          </tidy-row>
          @if (formatTaxRate()) {
            <tidy-row>
              <tidy-text [body]="('Tax Rate: ' | translate) + formatTaxRate()" />
            </tidy-row>
          }
          @if (item.platform_collected) {
            <tidy-row>
              <tidy-text [helper]="'Auto-collected by Airbnb/Vrbo'" />
            </tidy-row>
          }
        </tidy-alert>
      }

      <!-- Editable form -->
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-input
              [label]="'Name'"
              formControlName="name"
              [form]="form.controls.name"
              [icon]="'assets/svg/clipboard-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Category'"
              [form]="form.controls.bucket"
              formControlName="bucket"
              [items]="bucketItems"
              [icon]="'assets/svg/list-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Status'"
              [form]="form.controls.status"
              formControlName="status"
              [items]="statusItems"
              [icon]="'assets/svg/shield-checkmark-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="What To Do"
              formControlName="what_to_do"
              [form]="form.controls.what_to_do"
              [icon]="'assets/svg/create-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="How To Do It"
              formControlName="how_to_do_it"
              [form]="form.controls.how_to_do_it"
              [icon]="'assets/svg/build-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Frequency'"
              [form]="form.controls.frequency"
              formControlName="frequency"
              [items]="frequencyItems"
              [icon]="'assets/svg/repeat-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-datepicker
              [label]="'Next Due Date'"
              formControlName="next_due_at"
              [form]="form.controls.next_due_at"
              [icon]="'assets/svg/calendar-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Jurisdiction'"
              formControlName="jurisdiction"
              [form]="form.controls.jurisdiction"
              [icon]="'assets/svg/location-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="Notes"
              formControlName="notes"
              [form]="form.controls.notes"
              [icon]="'assets/svg/create-outline.svg'" />
          </tidy-row>
        </form>
      </tidy-card>

      @if (item.last_completed_at) {
        <tidy-row>
          <tidy-text [helper]="('Last completed: ' | translate) + (item.last_completed_at | date:'MMM d, yyyy')" />
        </tidy-row>
      }

      @if (item.source_url || item.confidence || item.citation || item.source_name || item.applies_to) {
        <tidy-alert class="black-background">
          @if (item.confidence) {
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/svg/information-circle-outline.svg'" class="body-size" />
              <tidy-text [body]="'Item Generated by Compliance Checker'" />
            </tidy-row>
            <tidy-row>
              <div style="display: flex; align-items: center; gap: 6px;">
                <tidy-text [helper]="getConfidenceLabel()" />
              </div>
            </tidy-row>
          }
          @if (item.applies_to) {
            <tidy-row>
              <tidy-text [helper]="('Applies to: ' | translate) + (item.applies_to | titlecase)" />
            </tidy-row>
          }
          @if (item.source_name) {
            <tidy-row>
              <tidy-text [helper]="('Source: ' | translate) + item.source_name" />
            </tidy-row>
          }
          @if (item.source_url) {
            <tidy-row>
              <div style="display: flex; align-items: center; gap: 6px;">
                <tidy-text [helper]="'URL:'" />
                <tidy-text
                  [actionBody]="item.source_url"
                  (action)="util.openUrl(item.source_url)"
                  class="link" />
              </div>
            </tidy-row>
          }
          @if (item.citation) {
            <tidy-row>
              <tidy-text [helper]="('Citation: ' | translate) + item.citation" />
            </tidy-row>
          }
        </tidy-alert>
      }

      <tidy-row [align]="'center'">
        <tidy-text
          [actionBody]="'Delete Item'"
          (action)="deleteItem()"
          class="delete-automation-link" />
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
